module.exports = __webpack_public_path__ + "static/img/14000758.e078e449.png";